export const text = {
  productUpdated: 'Cambios guardados para el producto.',
  productUpdatedError:
    'No se pudieron guardar los cambios. Por favor inténtalo de nuevo.'
};
